// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewcontrolNodeId } from './BrewcontrolNode';
import { brewcontrolRoutineRunId } from './BrewcontrolRoutineRun';
import { brewcontrolConfigVersionId } from './BrewcontrolConfigVersion';
import { z } from 'zod';
export const brewcontrolCalibrationId = (z.string());
export const brewcontrolCalibration = z.object({
    id: brewcontrolCalibrationId,
    node_id: brewcontrolNodeId,
    device_id: z.string(),
    form: z.string(),
    signal: z.string().nullable(),
    channel: z.string().nullable(),
    entry: z.unknown(),
    result: z.unknown().nullable(),
    routine_run_id: brewcontrolRoutineRunId.nullable(),
    config_version_id: brewcontrolConfigVersionId,
    created_by: z.string(),
    created_at: z.date(),
});
export const brewcontrolCalibrationInitializer = z.object({
    id: brewcontrolCalibrationId.optional(),
    node_id: brewcontrolNodeId,
    device_id: z.string(),
    form: z.string(),
    signal: z.string().optional().nullable(),
    channel: z.string().optional().nullable(),
    entry: z.unknown(),
    result: z.unknown().optional().nullable(),
    routine_run_id: brewcontrolRoutineRunId.optional().nullable(),
    config_version_id: brewcontrolConfigVersionId,
    created_by: z.string().optional(),
    created_at: z.date().optional(),
});
export const brewcontrolCalibrationMutator = z.object({
    id: brewcontrolCalibrationId.optional(),
    node_id: brewcontrolNodeId.optional(),
    device_id: z.string().optional(),
    form: z.string().optional(),
    signal: z.string().optional().nullable(),
    channel: z.string().optional().nullable(),
    entry: z.unknown().optional(),
    result: z.unknown().optional().nullable(),
    routine_run_id: brewcontrolRoutineRunId.optional().nullable(),
    config_version_id: brewcontrolConfigVersionId.optional(),
    created_by: z.string().optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=BrewcontrolCalibration.js.map